module.exports = __webpack_public_path__ + "img/P150T_weapon_160.3f9c072c.png";